import React from "react"
import { useTranslation } from "react-i18next"

import { Button, ButtonProps, ButtonVariant } from "shared/ui/buttons/Button"
import { Hamburger } from "shared/ui/hamburger/Hamburger"

export interface HeaderMenuButtonProps extends ButtonProps {
  isOpen: boolean
}

export const HeaderMenuButton = React.memo(
  ({ isOpen, ...props }: HeaderMenuButtonProps) => {
    const { t } = useTranslation()
    return (
      <Button
        variant={ButtonVariant.TERTIARY}
        className="header__menu-button"
        data-testid="menu-button"
        label={isOpen ? t("Menu.Close") : t("Menu.Open")}
        {...props}
      >
        <Hamburger isOpen={isOpen} />
      </Button>
    )
  }
)
